import { css } from '@emotion/react';
import { SearchType } from '@type/web/fraud';

import useResponsive from '@hook/useResponsive';

import Icon from '@components/common/Icon/Icon';

import { FIELD_TYPE } from '../constant';

interface FraudSearchTypeProps {
  visible: boolean;
  onToggle: () => void;
  type: SearchType;
  handleSelect: (type: SearchType) => void;
}

export default function FraudSearchType({
  visible,
  onToggle,
  type,
  handleSelect,
}: FraudSearchTypeProps) {
  const { isPC } = useResponsive();
  return (
    <div className="dropdown" css={dropdownStyle(visible)}>
      <div className="select" onClick={onToggle}>
        <span>{FIELD_TYPE[type]}</span>
        <Icon icon="arrowDown" size={14} />
      </div>
      {isPC && (
        <div className="list">
          <ul>
            {Object.entries(FIELD_TYPE).map(([key, value]) => (
              <li key={key}>
                <button
                  type="button"
                  aria-label="search"
                  onClick={() => handleSelect(key as SearchType)}
                >
                  {value}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

const dropdownStyle = (visible: boolean) => css`
  div {
    width: 100%;
    background-color: white;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    padding: 0 14px;
    justify-content: space-between;
    align-items: center;
  }
  .select {
    display: flex;
    height: 44px;
  }
  .list {
    display: ${visible || 'none'};
    margin-top: 3px;
    ul {
      padding: 10px 0;
    }
    li {
      button {
        text-align: left;
        display: block;
        width: 100%;
        padding: 10px 0;
        font-size: 15px;
        background: none;
      }
    }
  }
`;
